import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { IconModule } from './../icon/icon.module';
import { TruncateModule } from './../truncate/truncate.module';
import { TagComponent } from './tag.component';

@NgModule({
  declarations: [TagComponent],
  exports: [TagComponent],
  imports: [CommonModule, TruncateModule, IconModule],
})
export class TagModule {}
export { TagComponent } from './tag.component';
